import environment from '@menu-environment';
import { CountryCode } from 'core/config/country-code';

interface CountryCode {
  alpha2: string;
  alpha3: string;
  full: string;
}

export const normalise = (value?: string | null) => value?.toLocaleLowerCase() || '';

export class Country {
  private static Countries = CountryCode;
  private static DefaultCountry = Country.GetFromTwoCharCode(environment.DEFAULT_COUNTRY);

  static GetNormalisedCountry(country?: CountryCode) {
    return country
      ? {
        alpha2: normalise(country.alpha2),
        alpha3: normalise(country.alpha3),
        full: country.full
      }
      : undefined;
  }

  static FindCountry(prop: 'alpha2' | 'alpha3' | 'full', code: string) {
    const countryCode = normalise(code);
    return Country.GetNormalisedCountry(Country.Countries.find(country => normalise(country[prop]) === countryCode));
  }

  static GetFromTwoCharCode(countryCode: string) {
    const matchingCountry = Country.FindCountry('alpha2', countryCode);

    return matchingCountry || Country.FindCountry('alpha2', environment.DEFAULT_COUNTRY);
  }

  static GetFromThreeCharCode(countryCode: string) {
    return Country.FindCountry('alpha3', countryCode) || Country.DefaultCountry;
  }

  static GetFromFullName(name: string) {
    return Country.FindCountry('full', name) || Country.DefaultCountry;
  }

}